import { FC } from "react";
import styled from "styled-components";
import { AddressIndexResource } from "../shared/types/address";

const AddressWrapper = styled.address`
	display: flex;
	flex-direction: column;
	font-style: inherit;
`;

interface Props {
	address: AddressIndexResource;
}

export const Address: FC<Props> = ({ address }) => {
	return (
		<AddressWrapper>
			{address.additionalInfo && <span>{address.additionalInfo}</span>}
			<span>
				{address.zip} {address.city}
			</span>
			<span>
				{address.street} {address.houseNumber}
			</span>
			<span>{address.country.name}</span>
		</AddressWrapper>
	);
};
